import 'dayjs/locale/ru';
import dayjs from 'dayjs';
import { useState } from 'react';
import { db } from '../fierbase/config';
import Stack from '@mui/material/Stack';
import { useForm } from "react-hook-form";
import { useSelector } from 'react-redux';
import Select from '@mui/material/Select';
import { useAuth } from '../store/hooks/setting';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { collection, addDoc } from "firebase/firestore";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { PageNavigate } from '../component/navigate/pageNavigate';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
const AddTasks = () => {
    const history = useNavigate();
    const currentUser = useAuth();
    const [folderName, setFolderName] = useState('');
    const [datePickerValue, setDatePickerValue] = useState(dayjs(new Date),);
    const { register, formState: { errors }, handleSubmit } = useForm();
    const folder = useSelector(state => state.folder.folder);
    const handleTask = async (data) => {
        await addDoc(collection(db, "tasks"), {
            userID: currentUser.uid,
            description: data.description,
            foldername: data.foldername,
            listId: data.foldername,
            takname: data.taskName,
            completed: false,
            date: datePickerValue.$d.getTime(),
        });
        history('/alltasks')
    }
    return (
        <>
            <div className="container">
                <PageNavigate
                    pagetitle='Добавить задачу'
                />
                <form className="task-form task-page__form" onSubmit={handleSubmit(handleTask)}>
                    <div className="task-form__wrapper">
                        <div className="task-input">
                            <span className="form-group__text">Название задачи</span>
                            <input
                                style={errors.taskName && { border: "1px solid red" }}
                                {...register("taskName", { required: true })}
                                placeholder="Начните вводить...."
                            />
                            {errors.taskName?.type === 'required' && <p className="error" role="alert">Введите название задачи</p>}
                        </div>
                        <div className="task-input">
                            <span className="form-group__text">Описание задачи</span>
                            <textarea
                                style={errors.description && { border: "1px solid red" }}
                                {...register("description", { required: true })}
                                placeholder='Введите описание задачи.....'
                            />
                            {errors.description?.type === 'required' && <p className="error" role="alert">Введите описание задачи</p>}
                        </div>
                        <div className="task-date">
                            <span className="form-group__text">Дата</span>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
                                <div className="date-control">
                                    <Stack spacing={3}>
                                        <DatePicker
                                            value={datePickerValue}
                                            onChange={(newValue) => setDatePickerValue(newValue)}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Stack>
                                </div>
                            </LocalizationProvider>
                        </div>
                        <div className="task-input">
                            <span className="form-group__text">Название папки</span>
                            <FormControl sx={{ m: 0 }}>
                                <InputLabel style={{ lineHeight: "0,8em" }} htmlFor="grouped-select">Папки</InputLabel>
                                <Select
                                    defaultValue=""
                                    id="grouped-select"
                                    label="Grouping"
                                    onChange={e => setFolderName(e.target.value)}
                                    {...register("foldername", { required: true })}
                                >
                                    <MenuItem value={folderName}>
                                        <em>Выберите папку</em>
                                    </MenuItem>
                                    {folder.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item.foldername}
                                        >
                                            {item.foldername}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {errors.foldername?.type === 'required' && <p className="error" role="alert">Выберите папку</p>}
                        </div>
                        <button className="form-button" disabled={errors.foldername}>
                            Подтвердить
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}
export { AddTasks }